// -------------------------------
//
//  Validation - Required
//
// -------------------------------
function validationRequired(value) {
    if (value == null) {
        return "入力してください。";
    }
    const normalized = String(value).trim();
    if (normalized === "") {
        return "入力してください。";
    }
    return "";
}
// -------------------------------
//
//  Validation - Code
//
// -------------------------------
function validationCode(value) {
    if (value == null || value === "") {
        return "";
    }
    const regex = /[<>=\/"'`;(){}[\]]/;
    if (regex.test(String(value))) {
        return "使用できない文字が含まれています。";
    }
    return "";
}

// -------------------------------
//
//  Validation - Max Length
//
// -------------------------------
function validationMaxLength(value, maxLength) {
    if (value == null) {
        return "";
    }
    const normalized = String(value).trim();
    const length = [...normalized].length;
    if (length >= maxLength) {
        return `${maxLength}文字以内で入力してください。`;
    }
    return "";
}

// -------------------------------
//
//  Validation - Mail
//
// -------------------------------
function validationMail(value) {
    if (value == null || value === "") {
        return "";
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
        return "メールアドレスの形式で入力してください。";
    }
    return "";
}

// -------------------------------
//
//  Validation - Tel
//
// -------------------------------
function validationTel(value) {
    if (value == null || value === "") {
        return "";
    }
    const regex = /^[0-9\-]+$/;
    if (!regex.test(value)) {
        return "半角数字と半角ハイフンのみ入力可能です。";
    }
    return "";
}
// -------------------------------
//
//  Validation - Postal Code
//
// -------------------------------
function validationPostalCode(value) {
    if (value == null || value === "") {
        return "";
    }
    const regex = /^\d{3}-?\d{4}$/;
    if (!regex.test(String(value).trim())) {
        return "郵便番号の形式で入力してください。";
    }
    return "";
}
// -------------------------------
//
//  Validation - Select
//
// -------------------------------
function validationSelect(value) {
    if (value == null || value === "" || value === "--") {
        return "選択してください。";
    }
    return "";
}
// -------------------------------
//
//  Validation - Checkbox Group
//
// -------------------------------
function validationCheckboxGroup(elements) {
    const checkedItems = [...elements].filter((el) => el.checked);
    if (checkedItems.length === 0) {
        return "1つ以上選択してください。";
    }
    return "";
}
// -------------------------------
//
//  Validation - Date Select Group
//
// -------------------------------
function validationDateSelectGroup(values) {
    const isInvalid = values.some((value) => {
        return value == null || value === "" || value === "—" || value === "--";
    });
    if (isInvalid) {
        return "月・日・時・分をすべて選択してください。";
    }
    return "";
}
// -------------------------------
//
//  Validation - Agree
//
// -------------------------------
function validationAgree(value) {
    if (!value.checked) {
        return "個人情報の取り扱いについて、同意をお願いします。";
    }
    return "";
}

// -------------------------------
//
//  functions
//
// -------------------------------
//  エラーメッセージを挿入
function setErrorMessage(targetName, message) {
    const el = document.getElementById(`error-${targetName}`);
    if (el) {
        el.innerHTML = message;
    }
    return;
}
//  エラーメッセージを削除
function removeErrorMessage(targetName) {
    const el = document.getElementById(`error-${targetName}`);
    if (el) {
        el.innerHTML = "";
    }
    return;
}
//　配列が空か判定し真偽値を返す
function isEmptyArray(arr) {
    return arr.filter((v) => v !== "" && v != null).length === 0;
}
//  フォーム上部にエラーメッセージを挿入
function insertAlert(target) {
    if (target.querySelector(".p-form__alert")) return;
    const alert = document.createElement("p");
    alert.className = "p-form__alert";
    alert.textContent = "入力内容に不備があります。ご確認のうえ再度入力・送信してください。";
    target.prepend(alert);
}
//  フォーム上部のエラーメッセージを削除
function removeAlert(target) {
    const alert = target.querySelector(".p-form__alert");
    if (alert) alert.remove();
}

// -------------------------------
//
//  Validation Check
//
// -------------------------------

function runValidation() {
    //  ページ内のFormを取得
    const form = document.querySelector(".wpcf7 form");
    //  Formに内包される入力フィールドを取得
    const fields = form.querySelectorAll(".validation");
    //  nameの値（チェックボックスなど同名が重複する場合は1件のみ）を取得
    const names = [
        ...new Set([...fields].map((el) => el.name.replace(/\[\]$/, "")).filter(Boolean)),
    ];

    //  エラーカウント初期化
    let error_count = 0;

    names.forEach((el) => {
        let element = document.querySelector(`[name="${el}"]`);

        const result = [];
        // nameごとのバリデーション設定

        const date_value = [
            "date-1-day",
            "date-1-hour",
            "date-1-minutes",
            "date-2-day",
            "date-2-hour",
            "date-2-minutes",
        ];
        if (el === "user-name") {
            result.push(validationRequired(element.value));
            result.push(validationCode(element.value));
        }
        if (el === "tel") {
            result.push(validationRequired(element.value));
            result.push(validationTel(element.value));
        }
        if (el === "email") {
            result.push(validationRequired(element.value));
            result.push(validationMail(element.value));
        }
        if (el === "company-name") {
            result.push(validationMaxLength(element.value, 64));
        }
        if (el === "postal-code") {
            result.push(validationRequired(element.value));
            result.push(validationPostalCode(element.value));
        }
        if (el === "prefecture") {
            result.push(validationSelect(element.value));
        }
        if (el === "address-main") {
            result.push(validationRequired(element.value));
            result.push(validationMaxLength(element.value, 40));
        }
        if (el === "date-1-month") {
            const dateValues = [
                document.querySelector('select[name="date-1-month"]').value,
                document.querySelector('select[name="date-1-day"]').value,
                document.querySelector('select[name="date-1-hour"]').value,
                document.querySelector('select[name="date-1-minutes"]').value,
            ];
            result.push(validationDateSelectGroup(dateValues));
        }
        if (el === "date-2-month") {
            const dateValues = [
                document.querySelector('select[name="date-2-month"]').value,
                document.querySelector('select[name="date-2-day"]').value,
                document.querySelector('select[name="date-2-hour"]').value,
                document.querySelector('select[name="date-2-minutes"]').value,
            ];
            result.push(validationDateSelectGroup(dateValues));
        }
        if (el === "message") {
            result.push(validationRequired(element.value));
            result.push(validationMaxLength(element.value, 800));
        }
        if (el === "category") {
            const check_elements = document.querySelectorAll(`input[name="category[]"]`);
            element = document.querySelector(`[name="category[]"]`);
            result.push(validationCheckboxGroup(check_elements));
        }
        if (el === "agree") {
            result.push(validationAgree(element));
        }
        if (date_value.includes(el)) {
            return;
        }

        const parent = element.closest(".p-form__row");

        //  バリデーション結果（配列の中身）が空ではない場合
        //  エラーメッセージを挿入
        if (!isEmptyArray(result)) {
            //  エラーメッセージ挿入
            const error_message = result.filter(Boolean).join("／");
            setErrorMessage(el, error_message);
            //  背景色変更用class追加
            if (parent) {
                parent.classList.add("p-form__row--error");
                error_count++;
            }
        } else {
            removeErrorMessage(el);
            if (parent) {
                parent.classList.remove("p-form__row--error");
            }
        }
    });
    const form_frame = document.querySelector(".p-form__inner");

    if (error_count > 0) {
        insertAlert(form_frame);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        return false;
    } else {
        removeAlert(form_frame);
        return true;
    }
}

const form = document.querySelector(".wpcf7 form");
//CF７の送信イベントをキャッチ
if (form) {
    form.addEventListener(
        "submit",
        function (e) {
            const isValidation = runValidation();

            if (!isValidation) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        },
        true,
    );
}

//メール送信完了をキャッチして完了ページへ遷移
document.addEventListener("wpcf7mailsent", function (event) {
    const form = event.target;
    const formType = form.querySelector("#form-type")?.value;

    if (formType === "appointment") {
        window.location.href = "/appointment/complete-appointment";
    } else {
        window.location.href = "/contact/complete-contact";
    }
});
